export const messageContainerSx = {
    flexDirection: "column",
    width: "100%",
    paddingLeft: { xs: "16px", sm: "20px", md: "27px" },
    paddingRight: { xs: "16px", sm: "20px", md: "27px" },
    paddingTop: { xs: "12px", sm: "16px", md: "20px" },
    paddingBottom: { xs: "12px", sm: "16px", md: "20px" },
    fontFamily: "Poppins, -apple-system, Roboto, Helvetica, sans-serif",
    fontWeight: 400,
    display: "flex",
    overflowY: "auto",
    maxHeight: { xs: "calc(100vh - 200px)", sm: "calc(100vh - 180px)", md: "calc(100vh - 160px)" },
    // minHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 280px)", md: "calc(100vh - 260px)" },
    minHeight: { xs: "200px", sm: "250px", md: "300px" },
    maxWidth: "100%",
    flex: 1, // Ensure it takes available space
    scrollbarWidth: "thin",          // Firefox - show thin scrollbar
    scrollbarColor: "#c1c1c1 transparent", // Firefox scrollbar colors
    msOverflowStyle: "auto",         // IE 10+ - show scrollbar
    '&::-webkit-scrollbar': {
      width: "6px",                  // Chrome, Safari, Edge - thin scrollbar
    },
    '&::-webkit-scrollbar-track': {
      background: "transparent",
    },
    '&::-webkit-scrollbar-thumb': {
      background: "#c1c1c1",
      borderRadius: "3px",
      '&:hover': {
        background: "#a1a1a1",
      }
    },
    // Enhanced mobile experience
    '&::-webkit-scrollbar-thumb:active': {
      background: "#808080",
    }
  };


  export const dateSeparatorBoxSx = {
    display: "flex",
    alignItems: "center",
    my: { xs: 2, sm: 2.5, md: 3 },
    width: "100%",
    position: "relative",
  };
  
  export const dateSeparatorLineSx = {
    flex: 1,
    height: "1px",
    background: "linear-gradient(90deg, transparent, #e0e0e0, transparent)",
    mx: { xs: 1, sm: 1.5, md: 2 },
  };
  
  export const dateTextSx = {
    whiteSpace: "nowrap",
    color: "#666",
    fontWeight: 600,
    fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
    backgroundColor: "#fff",
    padding: { xs: "4px 8px", sm: "6px 12px", md: "8px 16px" },
    borderRadius: "12px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
    position: "relative",
    zIndex: 1,
  };
  
  export const typingMessageSx = {
    display: "flex",
    alignItems: "center",
    gap: { xs: "8px", sm: "10px", md: "12px" },
    padding: { xs: "8px 12px", sm: "10px 16px", md: "12px 20px" },
    backgroundColor: "#f8f9fa",
    borderRadius: "18px",
    marginBottom: { xs: "8px", sm: "10px", md: "12px" },
    maxWidth: "fit-content",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  };
  
  export const typingAvatarSx = {
    bgcolor: "primary.main", 
    height: { xs: "28px", sm: "30px", md: "32px" }, 
    width: { xs: "28px", sm: "30px", md: "32px" },
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  };
  
  export const expiredFileMessageSx = {
    marginTop: { xs: "8px", sm: "10px", md: "12px" },
    padding: { xs: "8px 12px", sm: "10px 16px", md: "12px 20px" },
    backgroundColor: "#f8d7da", 
    borderRadius: { xs: "8px", sm: "10px", md: "12px" }, 
    color: "#721c24",
    border: "1px solid #f5c6cb",
    fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.85rem" },
    fontWeight: 500,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    '&::before': {
      content: '"⚠️"',
      fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" }
    }
  };